var validMouseButtons = ['left', 'middle', 'right'];

export { validMouseButtons as default };
